import * as Yup from 'yup'

const FormularioSchema = Yup.object().shape({
    Carnet: Yup.string()
        .min(8, 'El carné es demasiado corto')
        .max(8, 'El carné es demasiado largo')
        .required('El carné es requerido')
        .matches(/^[a-zA-Z]{2}[\d]{6}/, {
            message: 'El número de carné es inválido',
            excludeEmptyString: true
        }),
    Proceso: Yup.string().required('El proceso es requerido'),
    Modalidad: Yup.string()
        .when('Proceso', {
            is: (val) => val === 'PROCESO DE GRADUACIÓN',
            then: Yup.string().required('La modalidad es requerida'),
            otherwise: Yup.string().notRequired(),
        }),
    MaesOpciones: Yup.string()
        .when('Modalidad', {
            is: (val) => val === 'ESPECIALIZACIÓN',
            then: Yup.string().required('La opción especialización es requerida'),
            otherwise: Yup.string().notRequired(),
        })
        .when('Proceso', {
            is: (val) => val === 'MAESTRÍA',
            then: Yup.string().required('La opción de maestría es requerida'),
            otherwise: Yup.string().notRequired(),
        }),
    TipoTitulacion: Yup.string().required('El tipo de titulación es requerida'),
    IdSede: Yup.string().required('La sede es requerida'),
    Email: Yup.string()
        .email('El email ingresado es inválido')
        .required('El email es requerido'),
    Telefono: Yup.string()
        .min(8, 'El teléfono es demasiado corto')
        .max(8, 'El teléfono es demasiado largo')
        .optional()
        .matches(/^[\d]{8}/, {
            message: 'El teléfono es inválido',
            excludeEmptyString: true
        })
})

export default FormularioSchema
